import { normalizeLocale } from '../i18n/locales.js';
import { applyFrClinicalTerminology } from '../i18n/terminology/fr-CA.js';

export const PROGRAM_ELIGIBLE_SECTORS = [
    'Clinical',
    'Long-Term Care',
    'Retirement',
];

export function isProgramEligibleSector(sectorName) {
    return PROGRAM_ELIGIBLE_SECTORS.includes(sectorName);
}

export function isDentalSector(sectorName) {
    return /\bdental\b/i.test(sectorName || '');
}

/**
 * Sector-aware care recipient terminology.
 * Clinical → patient(s); Long-Term Care / Retirement → resident(s).
 */
export function sectorCareRecipientTerm(
    sectorName,
    { plural = false, capitalize = false } = {}
) {
    const clinical = sectorName === 'Clinical';
    let term = clinical
        ? plural
            ? 'patients'
            : 'patient'
        : plural
        ? 'residents'
        : 'resident';

    if (capitalize) {
        return term.charAt(0).toUpperCase() + term.slice(1);
    }

    return term;
}

/** Possessive form, e.g. Residents' or Patients'. */
export function sectorCareRecipientPossessive(
    sectorName,
    { plural = true, capitalize = true } = {}
) {
    const term = sectorCareRecipientTerm(sectorName, { plural, capitalize });
    return `${term}'`;
}

/** Country- and locale-aware infection prevention terminology. */
export function infectionPreventionLabel(countryCode, locale) {
    if (normalizeLocale(locale) === 'fr') {
        return 'PCI';
    }

    return countryCode === 'US' ? 'IPC' : 'IPAC';
}

export function localizeInfectionPreventionTerminology(
    value,
    countryCode,
    locale
) {
    if (typeof value !== 'string') {
        return value;
    }

    const ipacLabel = infectionPreventionLabel(countryCode, locale);
    let localized = value;

    if (countryCode === 'US') {
        localized = localized
            .replace(/\bMIFUs\b/g, 'IFUs')
            .replace(/\bMIFU\b/g, 'IFU')
            .replace(/\bMiFUs\b/g, 'IFUs')
            .replace(/\bMiFU\b/g, 'IFU')
            .replace(
                /\bRoutine Practices\b(?! and Additional Precautions)/g,
                'Standard Precautions'
            )
            .replace(
                /\bRoutine Practice\b(?! and Additional Precautions)/g,
                'Standard Precautions'
            )
            .replace(/\bCore Elements\b/g, 'Standard Precautions');
    }

    if (ipacLabel !== 'IPAC') {
        localized = localized.replace(
            /\bIPAC\b(?!\s+(?:Consulting|Dashboard|LearnDash)|Consulting\.com)/g,
            ipacLabel
        );
    }

    if (normalizeLocale(locale) === 'fr') {
        localized = applyFrClinicalTerminology(localized);
    }

    return localized;
}
